<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="editableTabsValue" type="card" @tab-remove='removeTab' :before-leave='Tabever'>
    <el-tab-pane :key="item.name" v-for="(item) in editableTabs" :label="item.title" :name="item.name" :closable="item.closable">
      <component :is="item.content" @addTab="addTab()" @removeTab="removeTab(item.name)" :minor='22'></component>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * lx
 * 数据采集管理页面
 */
import {mapState} from 'vuex'
import SjcjAdd from '../../../../static/form/SjcjAdd.vue'
import SjcjLB from '../assembly/SjcjLB.vue'
import ComboBox from '../assembly/ComboBox.vue'
export default {
  components: {
    SjcjAdd,
    SjcjLB,
    ComboBox
  },
  data()
  {
    return {
      editableTabsValue: '1',
      editableTabs: [{
        title: '数据采集列表',
        name: '1',
        closable: false,
        ref: 'child',
        content: SjcjLB
      }],
      addobj: {
        title: '添加数据采集',
        name: '2',
        closable: true,
        content: SjcjAdd
      }
    }
  },
  computed:
  {
    ...mapState({
      getActiveName: state => state.activeName
    })
  },
  watch:
  {
    getActiveName:
    {
      handler(nval, oval)
      {
        if (nval.activeName)
          this.editableTabsValue = nval.activeName
        else
          this.editableTabsValue = this.editableTabsValue
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    Tabever(activeName, oldActiveName)
    {
      if (activeName === '1')
        this.$store.commit('onIsLb', '1')
      this.$store.commit('onActiveName', activeName)
    },
    //父组件新增添加Tabs
    addTab()
    {
      let that = this
      window.public.addTab(that)
    },
    //删除添加Tabs
    removeTab(targetName)
    {
      let that = this
      window.public.removeTab(targetName, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/Sjcjgl.vue